import { HELPER_ROLE, HELPER_ROLE_ID, ORGANIZER_ROLE_ID, USER_ROLE_ID } from "./jwt-response";

export class UsersDetailFilter {
    public static readonly ROLES: number[] = [ORGANIZER_ROLE_ID, HELPER_ROLE_ID, USER_ROLE_ID];
    constructor(
        private text?: string,
        private role?: number,
    ) {
    }
    static createUserDetailsFilter(params?: UsersDetailFilterParams): UsersDetailFilter {
        var raceFilter: UsersDetailFilter = new UsersDetailFilter();
        raceFilter.text = params?.text;
        raceFilter.role = params?.role;
        return raceFilter;
    }
}

export interface UsersDetailFilterParams {
    text?: string,
    role?: number,

}
